import { h } from "preact";
import LabelOption from "./label-option";
import { IOption, ITemplate, IReactConfiguration } from "../../typings";
import OutputController from "../../shared/controller/output-controller";
import TemplateController from "../../shared/controller/template-controller";
import Uploader from "../uploader";
import EventController from "../../shared/controller/event-controller";
import UnitSystemController from "../../shared/controller/unit-system-controller";
import SizeController from "../../shared/controller/size-controller";
import ColorController from "../../shared/controller/color-controller";

const LabelOptions: (props: ILabelOptionsProps) => JSX.Element = (
  props: ILabelOptionsProps,
): JSX.Element => (
  <div>
    {props.template?.parsed_options
      ?.sort(
        (optionA: IOption, optionB: IOption) =>
          optionA.attributes?.sort?.value - optionB.attributes?.sort?.value,
      )
      .map((option: IOption) => (
        <LabelOption {...props} key={option.key} option={option} />
      ))}
  </div>
);

export default LabelOptions;

interface ILabelOptionsProps {
  template: ITemplate;
  conf: IReactConfiguration;
  main: Uploader;

  eventController: EventController;
  outputController: OutputController;
  sizeController: SizeController;
  templateController: TemplateController;
  unitSystemController: UnitSystemController;
  colorController: ColorController;
  templateLoaded: boolean;
}
